import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["href", "title"]
const _hoisted_2 = { class: "promotion-notice__content" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 0,
  class: "promotion-notice__badge"
}
const _hoisted_6 = ["textContent"]

import LinkButton from '@lmt-rpb/Atoms/LinkButton/LinkButton.vue';
import { gaSelectContentAttr } from 'src/utils/analytics';
import { computed } from 'vue';

export interface Props {
	title: string;
	description: string;
	badgeText?: string;
	linkText?: string;
	link: string;
	linkTitle?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PromotionNotice',
  props: {
    title: {},
    description: {},
    badgeText: {},
    linkText: { default: 'Mehr erfahren' },
    link: {},
    linkTitle: {}
  },
  setup(__props: any) {



const TEXT_LIMITS = {
	BUTTON: 35,
	TITLE: 22,
	TEXT: 100,
	BADGE: 40,
} as const;

const ga4Attributes = gaSelectContentAttr({
	cId: __props.title,
	cType: 'ux_plugin_promotion_notice_click'
})
const buttonLabel = computed(() => __props.linkText.substring(0, TEXT_LIMITS.BUTTON));
const cardTitle = computed(() => __props.title.substring(0, TEXT_LIMITS.TITLE));
const cardText = computed(() => __props.description.substring(0, TEXT_LIMITS.TEXT));
const cardBadgeText = computed(() => __props.badgeText?.substring(0, TEXT_LIMITS.BADGE));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", _mergeProps({
    class: "promotion-notice",
    href: _ctx.link,
    title: _ctx.linkTitle
  }, _unref(ga4Attributes)), [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", {
        textContent: _toDisplayString(cardTitle.value)
      }, null, 8 /* PROPS */, _hoisted_3),
      _createElementVNode("p", {
        textContent: _toDisplayString(cardText.value)
      }, null, 8 /* PROPS */, _hoisted_4),
      _createVNode(LinkButton, {
        class: "promotion-notice__btn",
        theme: "inherit",
        tabindex: "-1",
        "with-icon": false,
        label: buttonLabel.value
      }, null, 8 /* PROPS */, ["label"])
    ]),
    (_ctx.badgeText?.trim())
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("p", {
            class: "promotion-notice__badge-text",
            textContent: _toDisplayString(cardBadgeText.value)
          }, null, 8 /* PROPS */, _hoisted_6)
        ]))
      : _createCommentVNode("v-if", true)
  ], 16 /* FULL_PROPS */, _hoisted_1))
}
}

})